module.exports = __webpack_public_path__ + "img/honor2.3ccfaca7.png";